import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExpenseEntryGridConfig } from './expenseEntryGridConfig.state';

export const getExpenseEntryGridConfigState = createFeatureSelector<ExpenseEntryGridConfig >('expenseEntryGridConfig');

export const getExpenseEntryGridConfig = createSelector(
  getExpenseEntryGridConfigState,
  (state) => state.expenseEntryGridConfig
);
